export default {
  yourSkills: "Your skills",
  skills: "Skills",
  skill: "Skill",
  synthesis: {
    synthesis: "Summary",
    attachments: "Attachments",
    evolution: "Evol.",
    noAttachment: "No attachment",
    notEvaluated: "Not evaluated",
    notEvaluatedShort: "—",
    levelOf: ({ named }) => `Level ${named("value")} out of ${named("max")}`,
    collapsePeriod: ({ named }) => `Hide period ${named("name")}`,
    expandPeriod: ({ named }) => `Show period ${named("name")}`,
    skillCount: ({ named }) => `${named("count")} ${named("count") > 1 ? "skills" : "skill"}`,
    attachmentCount: ({ named }) => `${named("count")} ${named("count") > 1 ? "attachments" : "attachment"}`,
    showMoreAttachments: ({ named }) =>
      `Show ${named("count")} ${named("count") > 1 ? "more attachments" : "more attachment"}`,
    showLessAttachments: "Show fewer attachments",
    mode: {
      title: "Summary mode",
      avg: "Average",
      max: "Maximum grade",
      last: "Last evaluation",
    },
    hide: "Hide",
    loading: "Loading skills synthesis...",
    seeProgression: "See progression",
  },
  last_skill_update: "Last saved",
  duration: "Duration",
  Category: "Category",
  "Skills saved successfully": "Skills saved successfully",
  next: "Next",
  previous: "Previous",
  seeHistoric: "View history",
  resetSkill: "Reset skill",
  justificativePieceSend: "Documentary proof sent",
  sendJustificativePiece: "Send documentary proof",
  justificativeFileDeposited: ({ plural, named }) =>
    plural([`${named("count")} file uploaded`, `${named("count")} files uploaded`]),
  impossibleJustificativeSending: "Addition of documentary proof possible after grading",
  stats: {
    no_data: "No data has yet been entered",
  },
  no_skills: "No skill entered for this category",
  no_skill_available: "No skill currently entered",
  no_skill_complete: "No skill completed",
  empty_config: "Atención: la configuración del módulo de competencias no está finalizada",
  skill_chart: "Skills chart",
  skill_category_chart: "Radar by skills block",
  skill_progression_chart: "Skill progression",
  skill_chart_pdf_name: "graphique-des-compétences",
  referential_visible: ({ plural }) => plural(["Active reference documentation", "Inactive reference documentation"]),
  session_visible: ({ plural }) => plural(["Active session", "Inactive session"]),
  generate_all_rncp_referential: "Générer tous les référentiels France Compétences",
  admin_config: {
    enable_on_all_training_course: {
      title: "Utiliser la configuration Admin sur toutes les promotions actives",
      confirm: {
        title: "Utiliser la configuration admin ?",
        subtitle:
          "Attention cela affectera la configuration admin à toutes les promotions actives, même celles qui utilisent une configuration personalisée",
      },
    },
    disable_on_all_training_course: {
      title: "Utiliser la configuration personnalisée sur toutes promotions actives",
      confirm: {
        title: "Utiliser la configuration personnalisée ?",
        subtitle:
          "Attention cela affectera la configuration personnalisée sur toutes les promotions actives, même celles qui utilisent la configuration admin",
      },
    },
  },
  skill_admin_config_in_use: "You are currently using the admin configuration for the periods.",
  notEvaluable: "Not assessable",
  notEvaluableAbbr: "NA",
  gradingScale: "Grading scale",
  skillLevelOption: ({ named }) => `Level ${named("level")}`,
};
